import { useLocation, Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import Button from '../components/Button'

const RegistrationSuccess = () => {
  const location = useLocation()
  const { eventName, eventSlug, isPaid, registrationId } = location.state || {}

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-cream to-primary-100 flex items-center justify-center px-4 py-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center"
      >
        {/* Check icon */}
        <div className="flex items-center justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
            <svg
              className="w-10 h-10 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          {isPaid ? 'Payment Successful!' : "You're All Set!"}
        </h1>

        <p className="text-gray-600 mb-1">
          {isPaid
            ? 'Your payment was processed and you are now registered.'
            : 'Your registration has been confirmed.'}
        </p>

        {eventName && (
          <p className="text-primary-700 font-semibold mt-3 mb-1">{eventName}</p>
        )}

        {registrationId && (
          <p className="text-xs text-gray-400 mt-1 mb-4">
            Registration #{registrationId}
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-3 mt-6">
          <Link to="/events" className="flex-1">
            <Button variant="secondary" className="w-full">
              Back to All Events
            </Button>
          </Link>

          {eventSlug && (
            <Link to={`/events/${eventSlug}`} className="flex-1">
              <Button variant="primary" className="w-full">
                View Event
              </Button>
            </Link>
          )}
        </div>
      </motion.div>
    </div>
  )
}

export default RegistrationSuccess
